import { api_react_v1_ai_cohort_notifications_users_path } from '@routes';

import request from './request';

export interface CreateAiCohortNotificationsUserParams {
  aiCohortNotificationId: number;
  emailAddresses: string[];
  userNote?: string;
}

export interface CreateAiCohortNotificationsUserResponse {
  success: boolean;
  error?: string;
}

export async function createAiCohortNotificationsUser({
  aiCohortNotificationId,
  emailAddresses,
  userNote,
}: CreateAiCohortNotificationsUserParams): Promise<CreateAiCohortNotificationsUserResponse> {
  const resp = await request('post', api_react_v1_ai_cohort_notifications_users_path(), {
    ai_cohort_notification_id: aiCohortNotificationId,
    recipient_emails: emailAddresses,
    user_note: userNote,
  });
  return resp;
}
